export enum RoutePaths {
  HOME = "/",
  LOGIN = "/login",
  CREATE_NEW_PASSWORD = "/create-new-password/:id",
  FORGOT_PASSWORD = "/forgot-password",
  ACCOUNT = '/account',
  DEVICES = '/devices',
  INVOICES = '/invoices',
}
